import { render, staticRenderFns } from "./jieshao.vue?vue&type=template&id=59df0fd9&scoped=true&"
import script from "./jieshao.vue?vue&type=script&lang=js&"
export * from "./jieshao.vue?vue&type=script&lang=js&"
import style0 from "./jieshao.vue?vue&type=style&index=0&id=59df0fd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59df0fd9",
  null
  
)

export default component.exports